import { useState ,useEffect} from 'react'
import { useNavigate } from 'react-router-dom';
import './CertHandler.css'
import axios from 'axios';
import Nav from '../nav_home_out/nav_home_out'

const url = "https://personal-portfolio-theta-blue.vercel.app/certificationupload"

function CertHandler() {
  const logout= useNavigate();
  const [postImage, setPostImage] = useState( { url:"",title:""})

  useEffect(()=>{
    if(localStorage.getItem('auth')=='false' || localStorage.getItem('auth')==null){
      logout('/admin')
    }
  },[])

  const createPost = async (newImage) => {
    try{
      await axios.post(url, newImage)
    }catch(error){
      console.log(error)
    }
    window.location.reload()
  }

  const handleSubmit = (e) => {
    e.preventDefault();
    createPost(postImage)
    console.log(postImage);
    console.log("Uploaded")
  }

  const handleFileUpload = async (e) => {
    const file = e.target.files[0];
    const base64 = await convertToBase64(file);
    setPostImage({ ...postImage, url : base64 })
  }

  const handleTitleUpload=async(e)=>{
    const filename=e.target.value;
    setPostImage({ ...postImage, title : filename })
  }

  return (
    <div className="CertificateUpload">
      <form onSubmit={handleSubmit} className='certificateUploadForm'>
        <h1>Upload Certificate</h1>
        <input 
          type="file"
          name="myFile"
          id='file-upload'
          accept='.jpeg, .png, .jpg, .jfif'
          onChange={(e) => handleFileUpload(e)}
          required
         />
         <input type='text' name='certificatename' required id='title-upload' onChange={(e) => handleTitleUpload(e)} placeholder='Enter Certificate Name'/>
         <button type='submit' className='btn btn-primary'>Submit</button>
      </form>
      <Nav/>
    </div>
  )
}

export default CertHandler


function convertToBase64(file){
  return new Promise((resolve, reject) => {
    const fileReader = new FileReader();
    fileReader.readAsDataURL(file);
    fileReader.onload = () => {
      resolve(fileReader.result)
    };
    fileReader.onerror = (error) => {
      reject(error)
    }
  })
}